export const dateTimeFormat = {
  yyyymmdd: 'yyyy-MM-dd',
  yyyymmddhhmm: 'yyyy-MM-dd hh:mms',
  yyyymmddhhmmss: 'yyyy-MM-dd hh:mm:ss',
  hhmm: 'hh:mm',
  momentYYYYMMDD: 'YYYY-MM-DD',
  momentYYYYMMDDhhmmss: 'YYYY-MM-DD HH:mm:ss',
  momentYYYYMMDDhhmm: 'YYYY-MM-DD HH:mm',
  momenthhmmsss: 'HH:mm:ss',
  momenthhmm: 'HH:mm',
};

export const configDateTimePicker = {
  enableTime: true,
  enableSeconds: true,
  noCalendar: true
};
export const configDatePicker = {
  wrap: true, // set wrap to true only when using 'input-group'
  altFormat: 'M j, Y',
  altInput: true,
  dateFormat: 'Y-m-d',
};

export const formatSecondToHHMMSS = function (time) {
  // Hours, minutes and seconds
  let hrs = ~~(time / 3600);
  let mins = ~~((time % 3600) / 60);
  let secs = ~~time % 60;

  // Output like "1:01" or "4:03:59" or "123:03:59"
  let ret = "";
  if (hrs > 0) {
    ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
  }
  ret += "" + mins + ":" + (secs < 10 ? "0" : "");
  ret += "" + secs;
  return ret;
}
